import { useModalityCategoryValue } from "@FillInTableContainer/shared/context/ModalityCategoryContext";
import {
  useTableCreatorFocusStatus,
  DEFAULT_FOCUS_STATUS,
} from "@FillInTableContainer/shared/context/TableCreatorFocusStatusContext";
import {
  useTableCreatorPositionInfo,
  DEFAULT_POSITION_INFO,
} from "@FillInTableContainer/shared/context/TableCreatorPositionInfoContext";
import {
  ValidatedInfoList,
  useValidatedInTableCreator,
} from "@FillInTableContainer/shared/context/ValidatedInTableCreatorContext";
import { useEntryDataValue } from "@stores/entryData";
import { getPressIdFromURL } from "@utils/getStateFromURL";

interface UseCheckValidationInTableCreatorReturn {
  handleCheckValidationHalf: () => boolean;
  handleCheckValidationFull: () => boolean;
}

export const useCheckValidationInClinicalTrialStatusTableCreator =
  (): UseCheckValidationInTableCreatorReturn => {
    const entryData = useEntryDataValue(getPressIdFromURL());
    const { changeValidatedInfo } = useValidatedInTableCreator();
    const { changeInfo } = useTableCreatorPositionInfo();
    const { changeFocusStatus } = useTableCreatorFocusStatus();
    const { updateModalityCategory } = useModalityCategoryValue();

    const checkModalityCategory = () => {
      const drugProfileTableList =
        entryData?.["Clinical Trial Status"]?.["Drug Profile"];
      const modalityValues = drugProfileTableList?.map((table) =>
        table.Modality.value?.map((shell) => shell.text),
      );

      const valueInfo = modalityValues?.flatMap((table, tableIndex) =>
        table.map((shell) => {
          if (updateModalityCategory[shell] === "") {
            return {
              groupTableKey: "Drug Profile",
              groupTableIndex: 0,
              tableKey: "Drug",
              tableIndex,
              groupShellKey: null,
              groupShellIndex: 0,
              shellKey: "Modality",
              shellIndex: 0,
              valueIndex: null,
              type: "alert",
              container: "shell",
            };
          }
          return null;
        }),
      );
      return valueInfo?.filter((item) => item !== null);
    };

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const checkClinicalTrialDesignOneTable = () => {
      const clinicalTrialDesignOneTableList =
        entryData?.["Clinical Trial Status"]?.["Clinical Trial Design-1"];

      const clinicalTrialDesignOneTableListLength =
        clinicalTrialDesignOneTableList?.length || 0;

      if (clinicalTrialDesignOneTableListLength === 0) return [];

      const valueInfo = clinicalTrialDesignOneTableList?.flatMap(
        (tableInfo, tableInfoIndex) => {
          const checkTrialIntervention =
            tableInfo["Trial Intervention"]?.length === 0;

          if (!checkTrialIntervention) return null;
          return [
            {
              groupTableKey: "Clinical Trial Design-1",
              groupTableIndex: 1,
              tableKey: "Clinical Design",
              tableIndex: tableInfoIndex,
              groupShellKey: null,
              groupShellIndex: 0,
              shellKey: "Trial Intervention",
              shellIndex: 0,
              valueIndex: null,
              type: "alert",
              container: "shell",
            },
          ];
        },
      );

      const sortedValidatedInfo =
        valueInfo?.filter((info) => info !== null) || [];

      return sortedValidatedInfo;
    };

    const handleCheckValidationHalf = () => {
      if (checkModalityCategory()?.length === 0) {
        changeInfo(DEFAULT_POSITION_INFO);
        changeFocusStatus(DEFAULT_FOCUS_STATUS);
        return true;
      }

      const validatedList = [...(checkModalityCategory() || [])];

      changeValidatedInfo(validatedList as ValidatedInfoList);
      return false;
    };

    const handleCheckValidationFull = () => {
      if (
        checkModalityCategory()?.length === 0
        // checkClinicalTrialDesignOneTable().length === 0
      ) {
        changeInfo(DEFAULT_POSITION_INFO);
        changeFocusStatus(DEFAULT_FOCUS_STATUS);
        return true;
      }

      const validatedList = [
        ...(checkModalityCategory() || []),
        // ...(checkClinicalTrialDesignOneTable() || []),
      ];

      changeValidatedInfo(validatedList as ValidatedInfoList);
      return false;
    };
    return {
      handleCheckValidationHalf,
      handleCheckValidationFull,
    };
  };
